module.exports = __webpack_public_path__ + "img/icon-globe-pdf.320ac578.svg";